/** @jsx jsx */
import { jsx, Styled, Flex, Container } from 'theme-ui'

import SectionHeading from './section-heading'

export default () =>
  <div
    id='matrix'
    sx={{ py: 5 }}>
    <Container>
      <SectionHeading>
        Virtual Community
      </SectionHeading>
      <Flex
        sx={{
          mx: -3,
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
        <div
          sx={{
            flex: 'none',
            p: 3,
            width: [ '100%', '50%' ],
          }}>
          <Styled.img
            src='/assets/sponsors/matrix.svg'
            sx={{
              width: '100%',
            }}
          />
        </div>
        <div
          sx={{
            flex: 'none',
            p: 3,
            width: [ '100%', '50%' ],
          }}>
          <Styled.h3>Matrix</Styled.h3>
          <Styled.p
            sx={{
              mb: 2
            }}>
            Q&amp;A, "the hallway track", sponsor chit-chat and general conversation will happen on Matrix, an open source decentralised messaging platform.
          </Styled.p>
          <Styled.p
            sx={{
              mb: 2
            }}>
          Join #general:commcon.xyz from any other federated Matrix server, or just sign up for a temporary CommCon Matrix account.
          </Styled.p>
          <Styled.p
              sx={{
              my: 0
              }}
              // dangerouslySetInnerHTML={{ __html: paragraphs(description) }}
          >
              Sponsored by <Styled.a href='https://modular.im'>modular.im</Styled.a> and The Matrix Foundation
          </Styled.p>
          <div>
            {/* <Styled.a href={mapURL}>View Map</Styled.a>
            {' | '} */}
            <Styled.a href="https://riot.commcon.xyz">Join the community</Styled.a>
          </div>
        </div>
      </Flex>
    </Container>
  </div>
